import * as React from "react";
import { MapPin } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const schedule = [{
  day: "Monday",
  hours: "8:00 AM – 5:00 PM"
}, {
  day: "Tuesday",
  hours: "8:00 AM – 5:00 PM"
}, {
  day: "Wednesday",
  hours: "8:00 AM – 5:00 PM"
}, {
  day: "Thursday",
  hours: "8:00 AM – 5:00 PM"
}, {
  day: "Friday",
  hours: "8:00 AM – 4:00 PM"
}, {
  day: "Saturday",
  hours: "By Appointment"
}, {
  day: "Sunday",
  hours: "Closed"
}];
export default function VisitOurStudio() {
  return <section data-section-id="117352" id="office-hours" className="w-full py-16 md:py-24 bg-background text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-12 text-center md:text-left">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-secondary font-sans mb-4">
            Visit Our Los Angeles Clinic
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl">
            Take the first step toward restorative sleep. Visit our state-of-the-art office to discuss CPAP alternatives and oral appliance therapy with our experts.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          {}
          <div className="bg-card rounded-2xl shadow-xl border border-border p-6 md:p-8">
            <h3 className="text-xl font-semibold text-secondary mb-6 font-sans">
              Clinical Hours
            </h3>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[150px] text-secondary font-bold">Day</TableHead>
                  <TableHead className="text-secondary font-bold">Hours</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {schedule.map((item, i) => <TableRow key={i} data-index={i}>
                    <TableCell className="font-medium text-secondary">{item.day}</TableCell>
                    <TableCell className="text-muted-foreground">{item.hours}</TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </div>

          {}
          <div className="flex flex-col gap-6 h-full">
            <div className="flex items-start gap-5 bg-card p-6 rounded-2xl shadow-xl border border-border transition-colors hover:border-primary/20">
              <div className="bg-primary/10 p-3 rounded-full shrink-0 border border-primary/20">
                <MapPin className="w-7 h-7 text-primary" aria-hidden="true" />
              </div>
              <div>
                <h3 className="text-sm font-medium text-muted-foreground uppercase tracking-wider mb-2">
                  Office Location
                </h3>
                <address className="not-italic text-2xl md:text-3xl font-bold text-primary font-sans leading-tight">
                  2002 South Hoover Street <br />
                  Los Angeles, CA 90007
                </address>
              </div>
            </div>

            <div className="w-full flex-grow min-h-[300px] rounded-2xl overflow-hidden shadow-xl border border-border bg-muted relative">
              <iframe src="https://maps.google.com/maps?q=8500%20Wilshire%20Blvd%2C%20Beverly%20Hills%2C%20CA%2090211&t=&z=14&ie=UTF8&iwloc=&output=embed" width="100%" height="100%" style={{
              border: 0
            }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" className="absolute inset-0 w-full h-full" title="Dentist for Sleep Apnea Office Location Map"></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>;
}